import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {NavigationItem} from '../types/navigation.types';

@Component({
  selector: 'cov-floating-menu',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './floating-menu.component.html',
  styleUrl: './floating-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatingMenuComponent {
  public navItems = input.required<NavigationItem[]>();

  public close = output<boolean>();
}
